var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotify56(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1425_8226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2857 24.9062L13.7536 37.3442C13.3762 38.6751 14.3691 40 15.7441 40C16.6584 40 17.4643 39.3963 17.7274 38.5146L21.5703 25.625L17.2845 24.9062H17.2857Z",
    fill: "#2567D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1429 29.9375L34.4286 34.25H35.1429V18.4375H34.4286L20.1429 22.75H18.7144V29.9375H20.1429Z",
    fill: "#B0D9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8571 22.75H20.1429V29.9375H15.8571C14.2798 29.9375 13 28.6497 13 27.0625V25.625C13 24.0378 14.2798 22.75 15.8571 22.75Z",
    fill: "#2B8BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4285 18.4375V17.7188C34.4285 17.3222 34.7487 17 35.1428 17H36.5713C36.9654 17 37.2856 17.3222 37.2856 17.7188V34.9688C37.2856 35.3653 36.9654 35.6875 36.5713 35.6875H35.1428C34.7487 35.6875 34.4285 35.3653 34.4285 34.9688V18.4375Z",
    fill: "#2B9AFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2858 27.0625H39.4286C39.0346 27.0625 38.7144 26.7403 38.7144 26.3438C38.7144 25.9472 39.0346 25.625 39.4286 25.625H42.2858C42.6798 25.625 43.0001 25.9472 43.0001 26.3438C43.0001 26.7403 42.6798 27.0625 42.2858 27.0625Z",
    fill: "#66BAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4288 22.75C39.2454 22.75 39.0633 22.6793 38.924 22.5392C38.6454 22.2589 38.6454 21.8037 38.924 21.5233L41.7812 18.6483C42.0597 18.368 42.5121 18.368 42.7907 18.6483C43.0693 18.9287 43.0693 19.3839 42.7907 19.6642L39.9335 22.5392C39.7943 22.6793 39.6109 22.75 39.4288 22.75Z",
    fill: "#66BAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2857 34.25C42.1023 34.25 41.9202 34.1793 41.7809 34.0392L38.9238 31.1642C38.6452 30.8839 38.6452 30.4287 38.9238 30.1483C39.2023 29.868 39.6547 29.868 39.9333 30.1483L42.7904 33.0233C43.069 33.3037 43.069 33.7589 42.7904 34.0392C42.6512 34.1793 42.4678 34.25 42.2857 34.25Z",
    fill: "#66BAFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1425_8226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 23,
    fill: "white",
    transform: "translate(13 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotify56);
export default __webpack_public_path__ + "static/media/notify_56.306ede24afbeab69bdef35d01694b029.svg";
export { ForwardRef as ReactComponent };